import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { currentConversationSidAtom } from '../../session';
import { useTwilioConversationCallbacks } from '../../session/chat/useTwilioConversationCallbacks';
import { useShowNewMessageToastCallback } from './useShowNewMessageToastCallback';

export function useConversationCallbacks() {
  const { joinConversation: joinTwilioConversation, leaveConversation: leaveTwilioConversation } =
    useTwilioConversationCallbacks();
  const setCurrentConversationSid = useSetAtom(currentConversationSidAtom);
  const showNewMessageToast = useShowNewMessageToastCallback();
  const joinConversation = useCallback(
    async function handleActiveConversation(activeConversationSid: string) {
      await joinTwilioConversation(activeConversationSid, {
        onMessageAdded: (message) => {
          showNewMessageToast(message);
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const leaveConversation = useCallback(
    function leaveConversationOnDismount(activeConversationSid: string) {
      setCurrentConversationSid('');
      leaveTwilioConversation(activeConversationSid);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return { joinConversation, leaveConversation };
}
